import { css } from '@emotion/core';
import { Button } from 'antd';
import React, { useState } from 'react';
import { colors } from '../../../constants';
import IconSvg from '../../common/IconSvg';

export default function PricingEditContainer ({
  active,
  children,
  onEditButtonClick
}) {
  const [hovering, setHovering] = useState(false);

  return (
    <div
      onMouseEnter={()=>setHovering(true)}
      onMouseLeave={()=>setHovering(false)}
      onFocus={()=>{}}
      onBlur={()=>{}}
      css={css`
        transition: all .25s ease;
        position: relative;
        margin-left: -3px;
        ${active ? `
          background-color: ${colors.whiteMediumBackground};
          border-left: 3px solid ${colors.blue};
          padding: 10px;
          width: 483px;
        ` : `
          background: ${colors.borderLight};
          border-left: 3px solid ${colors.whiteLightBackground};
          padding: 10px;
          width: 480px;
        `}
      `}
    >
      <Button
        onClick={onEditButtonClick}
        type="ghost"
        shape="circle"
        css={css`
          border: 0;
          position: absolute;
          top: 10px;
          right: 10px;
          pointer-events: ${active ? 'none' : 'auto'};
          opacity: ${!active && hovering ? '1' : '0'};
        `}
      >
        <IconSvg type="pencil" size={22} />
      </Button>
      {children}
    </div>
  )
}
